export const extraColors = {
  gray: ['#F1F2F3', '#818B92'],
  yellow: ['#F0B707'],
  orange: ['#D75202'],
}
